import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingState = signal<boolean>(false);
  private componentReadyState = signal<boolean>(false);

  // Public readonly signals
  readonly isLoading = this.loadingState.asReadonly();
  readonly isComponentReady = this.componentReadyState.asReadonly();

  /**
   * Set global loading state
   */
  setLoading(loading: boolean): void {
    this.loadingState.set(loading);
  }

  /**
   * Set component ready state with optional delay for smooth transitions
   */
  setComponentReady(ready: boolean, delay = 50): void {
    if (ready && delay > 0) {
      setTimeout(() => {
        this.componentReadyState.set(true);
      }, delay);
    } else {
      this.componentReadyState.set(ready);
    }
  }

  /**
   * Simulate smooth component initialization
   */
  async initializeComponent(initDelay = 50): Promise<void> {
    this.componentReadyState.set(false);

    return new Promise((resolve) => {
      setTimeout(() => {
        this.componentReadyState.set(true);
        resolve();
      }, initDelay);
    });
  }

  /**
   * Reset all loading states
   */
  reset(): void {
    this.loadingState.set(false);
    this.componentReadyState.set(false);
  }
}
